export const getSampleViewUrl = ({
  evalSetId,
  filename,
  sampleId,
  epoch,
}: {
  evalSetId: string;
  filename: string;
  sampleId: string;
  epoch: number;
}) =>
  `/eval-set/${encodeURIComponent(evalSetId)}#/logs/${encodeURIComponent(filename)}/samples/sample/${encodeURIComponent(sampleId)}/${epoch}/`;
